import {
  commonUrl,
  postRequest,
  ResponseDI,
} from "../../../base/services/urlService";
import AppStore, { SiteMapItemDI } from "../../../base/stores/AppStore";
import { LessonDI } from "../types";

interface AddLessonResponseResultDI {
  lesson: SiteMapItemDI;
}

export const addLesson = async (lesson: LessonDI) => {
  const response = await postRequest<
    LessonDI,
    ResponseDI<AddLessonResponseResultDI>
  >(`${commonUrl}/api/lesson/AddLesson`, lesson);
  return response.result;
};
